import { css } from '@emotion/react'
import type React from 'react'
import { Image } from '../image/Image'

type props = {
  title: string
  src: any
  alt: string
}

export const Title: React.FC<props> = ({ alt, src, title }) => {
  const titleStyling = css`
    > span {
      display: inline-block;
      font-size: 1.1rem;
      margin-left: 30px;
      white-space: nowrap;

      @media (max-width: 320px) {
        white-space: normal;
      }
    }
  `
  return (
    <div className="fr w100 mt20 mb20" css={titleStyling}>
      <Image height={55} width={55} alt={alt} src={src} />
      <span>{title}</span>
    </div>
  )
}
